// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"607":"f6a09305","659":"f6a09305","804":"f6a09305"}[chunkId] + ".chunk.css";
};